import { PROFILE_TYPES } from '@/api/config'

export default class Profile {
  static SWITCH_AUDITOR = 'auditor'
  static SWITCH_ADMINISTRATOR = 'administrator'
  static SWITCH_MANAGER = 'manager'
  static SWITCH_CUSTOMER = 'customer'
  static SWITCH_HR = 'human-resource'

  constructor (id, name, userId, profileType, profileTypeDisplay) {
    this.id = id
    this.name = name
    this.userId = userId
    this.profileType = profileType
    this.profileTypeDisplay = profileTypeDisplay
  }

  static asProfiles (json) {
    return json.map(profile => {
      return Profile.asProfile(profile)
    })
  }

  static asProfile (json) {
    return new Profile(
      json.id,
      json.name,
      json.user_pk,
      json.profile_type,
      json.profile_type_display
    )
  }

  isCustomer () {
    return this.profileType === PROFILE_TYPES.CUSTOMER
  }

  isAuditor () {
    return this.profileType === PROFILE_TYPES.AUDITOR
  }

  isAdministrator () {
    return this.profileType === PROFILE_TYPES.ADMINISTRATOR
  }

  isManager () {
    return this.profileType === PROFILE_TYPES.MANAGER
  }

  isHR () {
    return this.profileType === PROFILE_TYPES.HR
  }

  getSwitchType () {
    switch (this.profileType) {
      case PROFILE_TYPES.AUDITOR: return Profile.SWITCH_AUDITOR
      case PROFILE_TYPES.ADMINISTRATOR: return Profile.SWITCH_ADMINISTRATOR
      case PROFILE_TYPES.MANAGER: return Profile.SWITCH_MANAGER
      case PROFILE_TYPES.CUSTOMER: return Profile.SWITCH_CUSTOMER
      case PROFILE_TYPES.HR: return Profile.SWITCH_HR
    }
  }

  static getProfileTypeDisplay (profileType) {
    if (profileType === PROFILE_TYPES.CUSTOMER) {
      return 'Customer'
    }
    if (profileType === PROFILE_TYPES.AUDITOR) {
      return 'Auditor'
    }
    if (profileType === PROFILE_TYPES.ADMINISTRATOR) {
      return 'Administrator'
    }
    if (profileType === PROFILE_TYPES.MANAGER) {
      return 'Manager'
    }
    if (profileType === PROFILE_TYPES.HR) {
      return 'Human resource'
    }
  }
}
